import { captureEvent } from '../../posthog'

type AlertToggleSurface = 'card' | 'settings_tab' | 'edit_view'

export function captureAlertActiveToggled(
  alert: { alertTypes?: string[] },
  active: boolean,
  surface: AlertToggleSurface
) {
  captureEvent('alert_active_toggled', {
    active,
    surface,
    has_autotrade: alert.alertTypes?.includes('webhook') ?? false,
  })
}
